import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import React from 'react'

import { convertDateTimeToPreferedTimezone } from 'data/dateTime/convertDateTimeToPreferedTimezone'
import T from 'T'
import { getExceptionAuditSummary, getExceptionReviewAudit } from 'utils/exceptionAudit'

import type { ExceptionShape } from './types'

// Created/updated caption at the card bottom, fed by the exception's Envers revisions
// (createdByUser arrives resolved). Renders nothing until audit data exists.
type ExceptionAuditCaptionProps = {
  exception?: ExceptionShape
  revisions?: unknown[]
}

const formatAuditLine = (header: string, name: string, at: string): string => {
  const { onlyDate, onlyTime } = at ? convertDateTimeToPreferedTimezone({ dateTime: at }) : { onlyDate: '', onlyTime: '' }
  const when = [onlyDate, onlyTime].filter(Boolean).join(' ')
  return [header, name, when && `· ${when}`].filter(Boolean).join(' ')
}

const ExceptionAuditCaption: React.FC<ExceptionAuditCaptionProps> = ({ exception, revisions }) => {
  const { createdByName, createdAt, updatedByName, updatedAt, hasUpdate } = getExceptionAuditSummary(revisions, exception)
  const review = getExceptionReviewAudit(revisions)
  const showCreated = Boolean(createdByName)
  const showUpdated = hasUpdate && Boolean(updatedByName)

  if (!showCreated && !showUpdated && !review) return null

  return (
    <Stack mt={1}>
      {showCreated && (
        <Typography color="text.secondary" variant="caption">
          {formatAuditLine(T.CREATED_BY_HEADER, createdByName, createdAt)}
        </Typography>
      )}
      {showUpdated && (
        <Typography color="text.secondary" variant="caption">
          {formatAuditLine(T.UPDATED_BY_HEADER, updatedByName, updatedAt)}
        </Typography>
      )}
      {review && (
        <Typography color="text.secondary" variant="caption">
          {formatAuditLine(review.status === 'confirmed' ? T.CONFIRMED_BY_HEADER : T.REJECTED_BY_HEADER, review.userName, review.at)}
        </Typography>
      )}
    </Stack>
  )
}

export default ExceptionAuditCaption
